export default "__VITE_ASSET__CeCUGiko__"